import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({ title: "Favorites Panel Config" })
export default class RefineTextPanelConfig {
	@Input({ type: InputType.TEXT, title: "Query Paramter" })
	public paramName: string;

	@Input({ type: InputType.JSON, title: "Favorite Params" })
	public favoriteParams: object;

	@Input({type: InputType.NUMBER, title: "Page Size"})
	public pageSize?: number;
}



// WEBPACK FOOTER //
// ./src/panels/favorites/FavoritesPanelConfig.ts